export const validation = {
  subscriptionName: "Name is required",
  subscriptionAmount: "Amount is required",
  storage: "Storage is required",
};
